import {
    Box,
    Card,
    List,
    ListItemButton,
    Stack,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material'
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { APP_TOP_INDENT, APP_TOP_INDENT_MOBILE } from '../../../constants/app.indents'
import {
    ASSISTANT_USAGE_AGREEMENT_ROUTE,
    PERSONAL_DATA_AGREEMENT_ROUTE,
    USER_AGREEMENT_ROUTE,
} from '../../../constants/routing.constants'
import NewFileIcon from './../../../assets/icons/NewFile.svg?react'

const links = [
    {
        title: 'Пользовательское соглашение',
        description: 'Пользовательское соглашение о предоставлении доступа к ARHIASSISTANT',
        href: USER_AGREEMENT_ROUTE,
    },
    {
        title: 'Условие использования AI-ассистентов',
        description: 'Условия передачи запросов в нейросети через ARHIASSISTANT',
        href: ASSISTANT_USAGE_AGREEMENT_ROUTE,
    },
    {
        title: 'Обработка персональных данных',
        description: 'Согласие на обработку персональных данных/условия обработки cookie-файлов',
        href: PERSONAL_DATA_AGREEMENT_ROUTE,
    },
]

export const TermsOfUsePage: FC = () => {
    const { breakpoints } = useTheme()
    const navigate = useNavigate()

    const isMobile = useMediaQuery(breakpoints.down('md'))
    const iconSize = isMobile ? 20 : 24

    return (
        <Card
            sx={{
                height: '100%',
                maxHeight: `calc(100dvh - ${isMobile ? APP_TOP_INDENT_MOBILE : APP_TOP_INDENT}px)`,
                p: 0,
            }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                    p: isMobile ? 2 : 4,
                    pb: isMobile ? 2 : 3,
                }}>
                <Typography
                    variant="Header3"
                    sx={{
                        color: '#1B1C1D',
                    }}>
                    Документы
                </Typography>
            </Stack>
            <List
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    p: isMobile ? '0 16px' : '0 32px',
                    gap: 1,
                }}>
                {links.map(({ title, description, href }) => (
                    <ListItemButton
                        key={href}
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            p: '20px',
                            gap: 2,
                            border: '1px solid #E7E8EE',
                            borderRadius: '20px',
                            backgroundColor: 'transparent',

                            ':hover': {
                                backgroundColor: '#F6F6F6',
                            },
                        }}
                        onClick={() => navigate(href)}>
                        <Box
                            sx={{
                                minWidth: `${iconSize}px`,
                                minHeight: `${iconSize}px`,
                            }}>
                            <NewFileIcon width={iconSize} height={iconSize} color="#5A5F72" />
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px',
                            }}>
                            <Typography variant="h5">{title}</Typography>
                            <Typography variant="body2" color="#5A5F72">
                                {description}
                            </Typography>
                        </Box>
                    </ListItemButton>
                ))}
            </List>
        </Card>
    )
}
